import React, { useContext } from 'react';

import { Grid, Typography } from '@mui/material';
import { Screen } from '../../components';
import { makeStyles } from '@mui/styles';
import MetricCard from '../../components/MetricCard/MetricCard';
import { PatientListsCards } from './components';
import { UserContext } from '../../lib/contexts';
import GraphCard from '../../components/GraphCard';
import MetricDashboardScreen from '../MetricDashboardScreen';
const useStyles = makeStyles((theme) => ({
  screen: {
    width: '96%',
    margin: '10px auto auto',
  },
  dashboard: {
    width: '92%',
    margin: 'auto',
    '& h2': {
      width: '100%',
      fontSize: 20,
      marginTop: 20,
      marginBottom: 20,
      color: theme.palette.admin.main,
      display: 'block',
    },
  },
  patientLists: {
    marginTop: 20,
  },
}));

const TestScreen = () => {
  const classes = useStyles();
  const {
    state: { first_name },
  } = useContext(UserContext);
  //const devMode = ['localhost', 'dev'].includes(process.env.REACT_APP_SYSTEM_ENV);

  return (
    <Screen
      title={'Dashboard - Diet ID'}
      showSidebarNav={true}
      admin={true}
    >
      <Grid
        container
        alignItems="center"
        spacing={0}
        className={classes.screen}
      >
        <Typography variant={'subtitle1'}>Welcome, {first_name && first_name + ','} to the Test Dashboard</Typography>
        <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
          spacing={0}
          className={classes.dashboard}
        >
          <Typography
            variant={'h2'}
            color={'primary'}
          >
            Test 1
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0}
          >
            {/*        <MetricCard slug={'total_users'}/>
                <MetricCard slug={'total_new_messages'}/>*/}
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0}
          >
            <MetricDashboardScreen />
            {/*        <MetricCard slug={'total_users'}/>
                <MetricCard slug={'total_new_messages'}/>*/}
          </Grid>
          <Typography
            variant={'h2'}
            color={'primary'}
          >
            Test 2
          </Typography>
          <Grid
            container
            item
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={0}
            className={classes.patientLists}
          >
            <GraphCard key={'total_users'} />
          </Grid>
        </Grid>
      </Grid>
    </Screen>
  );
};

export default TestScreen;
